// export const BASE_URL = `http://localhost:5000`;
export const BASE_URL = `https://api.price-monitor.afaqtel.ir`;
// export const AED_PRICE = `https://call4.tgju.org/ajax.json`;
export const AED_PRICE = `${BASE_URL}/currency/aed`;
export const PRODUCTS_URL = `${BASE_URL}/products`;
